export { default as AddFilledIcon } from './add-filled.svg?inline'
export { default as AddOutlineIcon } from './add-outline.svg?inline'
export { default as AddIcon } from './add.svg?inline'
export { default as AnswerIcon } from './answer.svg?inline'
export { default as ApplePayIcon } from './apple-pay.svg?inline'
export { default as ArrowRightIcon } from './arrow-right.svg?inline'
export { default as AtmIcon } from './atm.svg?inline'
export { default as AttachmentIcon } from './attachment.svg?inline'
export { default as BackIcon } from './back.svg?inline'
export { default as BackspaceIcon } from './backspace.svg?inline'
export { default as BankIcon } from './bank.svg?inline'
export { default as BillCheckIcon } from './bill-check.svg?inline'
export { default as BillFilledIcon } from './bill-filled.svg?inline'
export { default as BillOutlineIcon } from './bill-outline.svg?inline'
export { default as BlikIcon } from './blik.svg?inline'
export { default as BulletIcon } from './bullet.svg?inline'
export { default as CalendarIcon } from './calendar.svg?inline'
export { default as CameraIcon } from './camera.svg?inline'
export { default as CardAddIcon } from './card-add.svg?inline'
export { default as CardChangeIcon } from './card-change.svg?inline'
export { default as CardCheckIcon } from './card-check.svg?inline'
export { default as CardCrossIcon } from './card-cross.svg?inline'
export { default as CardCrossedIcon } from './card-crossed.svg?inline'
export { default as CardCvvIcon } from './card-cvv.svg?inline'
export { default as CardFilledIcon } from './card-filled.svg?inline'
export { default as CardInstallmentsIcon } from './card-installments.svg?inline'
export { default as CardOutlineIcon } from './card-outline.svg?inline'
export { default as CartFilledIcon } from './cart-filled.svg?inline'
export { default as CartOutlineIcon } from './cart-outline.svg?inline'
export { default as CashFilledIcon } from './cash-filled.svg?inline'
export { default as CashOutlineIcon } from './cash-outline.svg?inline'
export { default as CashbackIcon } from './cashback.svg?inline'
export { default as CategoriesIcon } from './categories.svg?inline'
export { default as ChartFilledIcon } from './chart-filled.svg?inline'
export { default as ChartOutlineIcon } from './chart-outline.svg?inline'
export { default as CheckMarkIcon } from './check-mark.svg?inline'
export { default as CheckmarkFilledIcon } from './checkmark-filled.svg?inline'
export { default as CheckmarkOutlineIcon } from './checkmark-outline.svg?inline'
export { default as ChevronDownIcon } from './chevron-down.svg?inline'
export { default as ChevronLeftAltIcon } from './chevron-left-alt.svg?inline'
export { default as ChevronLeftIcon } from './chevron-left.svg?inline'
export { default as ChevronRightAltIcon } from './chevron-right-alt.svg?inline'
export { default as ChevronRightIcon } from './chevron-right.svg?inline'
export { default as ChevronUpIcon } from './chevron-up.svg?inline'
export { default as ClickToPayIcon } from './click-to-pay.svg?inline'
export { default as ClockIcon } from './clock.svg?inline'
export { default as CloseBoldIcon } from './close-bold.svg?inline'
export { default as CloseIcon } from './close.svg?inline'
export { default as ContactlessIcon } from './contactless.svg?inline'
export { default as CopyIcon } from './copy.svg?inline'
export { default as CreditsFilledIcon } from './credits-filled.svg?inline'
export { default as CreditsOutlineIcon } from './credits-outline.svg?inline'
export { default as CrossmarkFilledIcon } from './crossmark-filled.svg?inline'
export { default as CrossmarkOutlineIcon } from './crossmark-outline.svg?inline'
export { default as DealsIcon } from './deals.svg?inline'
export { default as DecreaseIcon } from './decrease.svg?inline'
export { default as DeferralIcon } from './deferral.svg?inline'
export { default as DeleteFilledIcon } from './delete-filled.svg?inline'
export { default as DeleteOutlineIcon } from './delete-outline.svg?inline'
export { default as DesktopIcon } from './desktop.svg?inline'
export { default as DetailsIcon } from './details.svg?inline'
export { default as DirectDebitIcon } from './direct-debit.svg?inline'
export { default as DonationsIcon } from './donations.svg?inline'
export { default as DownloadIcon } from './download.svg?inline'
export { default as EditIcon } from './edit.svg?inline'
export { default as EmailAddIcon } from './email-add.svg?inline'
export { default as EmailIcon } from './email.svg?inline'
export { default as ExpensesFilledIcon } from './expenses-filled.svg?inline'
export { default as ExpensesOutlineIcon } from './expenses-outline.svg?inline'
export { default as ExpressAltIcon } from './express-alt.svg?inline'
export { default as ExpressIcon } from './express.svg?inline'
export { default as EyeOffIcon } from './eye-off.svg?inline'
export { default as EyeIcon } from './eye.svg?inline'
export { default as FaceIdIcon } from './face-id.svg?inline'
export { default as FastBankTransferIcon } from './fast-bank-transfer.svg?inline'
export { default as FileDownloadIcon } from './file-download.svg?inline'
export { default as FileFilledIcon } from './file-filled.svg?inline'
export { default as FileOutlineIcon } from './file-outline.svg?inline'
export { default as FileUploadIcon } from './file-upload.svg?inline'
export { default as FilterActiveIcon } from './filter-active.svg?inline'
export { default as FilterIcon } from './filter.svg?inline'
export { default as FingerprintIcon } from './fingerprint.svg?inline'
export { default as FlashOffIcon } from './flash-off.svg?inline'
export { default as FlashIcon } from './flash.svg?inline'
export { default as ForwardIcon } from './forward.svg?inline'
export { default as FullReturnIcon } from './full-return.svg?inline'
export { default as FxRateFilledIcon } from './fx-rate-filled.svg?inline'
export { default as FxRateOutlineIcon } from './fx-rate-outline.svg?inline'
export { default as GhostDoneIcon } from './ghost-done.svg?inline'
export { default as GifIcon } from './gif.svg?inline'
export { default as GiftFilledIcon } from './gift-filled.svg?inline'
export { default as GiftOutlineIcon } from './gift-outline.svg?inline'
export { default as GooglePayIcon } from './google-pay.svg?inline'
export { default as GraphIcon } from './graph.svg?inline'
export { default as HomeFilledIcon } from './home-filled.svg?inline'
export { default as HomeIcon } from './home.svg?inline'
export { default as ImageIcon } from './image.svg?inline'
export { default as InfoIcon } from './info.svg?inline'
export { default as InstallmentsExistingIcon } from './installments-existing.svg?inline'
export { default as InstallmentsFilledIcon } from './installments-filled.svg?inline'
export { default as InstallmentsFreeIcon } from './installments-free.svg?inline'
export { default as InstallmentsNewIcon } from './installments-new.svg?inline'
export { default as InstallmentsOutlineIcon } from './installments-outline.svg?inline'
export { default as InsuranceFilledIcon } from './insurance-filled.svg?inline'
export { default as InsuranceOutlineIcon } from './insurance-outline.svg?inline'
export { default as LawIcon } from './law.svg?inline'
export { default as LimitsIcon } from './limits.svg?inline'
export { default as LinkIcon } from './link.svg?inline'
export { default as ListIcon } from './list.svg?inline'
export { default as LocationIcon } from './location.svg?inline'
export { default as LockIcon } from './lock.svg?inline'
export { default as LogoutIcon } from './logout.svg?inline'
export { default as MapIcon } from './map.svg?inline'
export { default as MenuIcon } from './menu.svg?inline'
export { default as MessageIcon } from './message.svg?inline'
export { default as ModeAutoIcon } from './mode-auto.svg?inline'
export { default as ModeDarkIcon } from './mode-dark.svg?inline'
export { default as ModeLightIcon } from './mode-light.svg?inline'
export { default as MoreFilledIcon } from './more-filled.svg?inline'
export { default as MoreOutlineIcon } from './more-outline.svg?inline'
export { default as MoreVerticalIcon } from './more-vertical.svg?inline'
export { default as NoteIcon } from './note.svg?inline'
export { default as NotificationIcon } from './notification.svg?inline'
export { default as NumberFourIcon } from './number-four.svg?inline'
export { default as NumberOneIcon } from './number-one.svg?inline'
export { default as NumberThreeIcon } from './number-three.svg?inline'
export { default as NumberTwoIcon } from './number-two.svg?inline'
export { default as OnlineShoppingIcon } from './online-shopping.svg?inline'
export { default as PartialRefundIcon } from './partial-refund.svg?inline'
export { default as PauseIcon } from './pause.svg?inline'
export { default as PayInNIcon } from './pay-in-n.svg?inline'
export { default as PendingFilledIcon } from './pending-filled.svg?inline'
export { default as PendingOutlineIcon } from './pending-outline.svg?inline'
export { default as PhoneAddIcon } from './phone-add.svg?inline'
export { default as PhonePayIcon } from './phone-pay.svg?inline'
export { default as PhoneIcon } from './phone.svg?inline'
export { default as PhysicalCardsIcon } from './physical-cards.svg?inline'
export { default as PinIcon } from './pin.svg?inline'
export { default as QrIcon } from './qr.svg?inline'
export { default as ReceiptAddIcon } from './receipt-add.svg?inline'
export { default as ReceiptIcon } from './receipt.svg?inline'
export { default as RedirectIcon } from './redirect.svg?inline'
export { default as RefreshIcon } from './refresh.svg?inline'
export { default as RemoveFilledIcon } from './remove-filled.svg?inline'
export { default as RemoveOutlineIcon } from './remove-outline.svg?inline'
export { default as RemoveIcon } from './remove.svg?inline'
export { default as ReturnIcon } from './return.svg?inline'
export { default as RotateIcon } from './rotate.svg?inline'
export { default as ScanIcon } from './scan.svg?inline'
export { default as SearchIcon } from './search.svg?inline'
export { default as SecurityIcon } from './security.svg?inline'
export { default as SendIcon } from './send.svg?inline'
export { default as SettingsFilledIcon } from './settings-filled.svg?inline'
export { default as SettingsOutlineIcon } from './settings-outline.svg?inline'
export { default as ShareIcon } from './share.svg?inline'
export { default as ShoppingFilledIcon } from './shopping-filled.svg?inline'
export { default as ShoppingOutlineIcon } from './shopping-outline.svg?inline'
export { default as SliderIcon } from './slider.svg?inline'
export { default as SnapAddIcon } from './snap-add.svg?inline'
export { default as SnapCheckIcon } from './snap-check.svg?inline'
export { default as SnapCrossIcon } from './snap-cross.svg?inline'
export { default as SnapFilledIcon } from './snap-filled.svg?inline'
export { default as SnapOutlineIcon } from './snap-outline.svg?inline'
export { default as SnapPendingIcon } from './snap-pending.svg?inline'
export { default as SortIcon } from './sort.svg?inline'
export { default as SoundIcon } from './sound.svg?inline'
export { default as SplitIcon } from './split.svg?inline'
export { default as SwipeDownIcon } from './swipe-down.svg?inline'
export { default as TooltipFilledIcon } from './tooltip-filled.svg?inline'
export { default as TooltipOutlineIcon } from './tooltip-outline.svg?inline'
export { default as TopUpIcon } from './top-up.svg?inline'
export { default as TransfersOutlineIcon } from './transfers-outline.svg?inline'
export { default as TwistoFilledIcon } from './twisto-filled.svg?inline'
export { default as TwistoOutlineIcon } from './twisto-outline.svg?inline'
export { default as TwistoPayFilledIcon } from './twisto-pay-filled.svg?inline'
export { default as TwistoPayOutlineIcon } from './twisto-pay-outline.svg?inline'
export { default as UnlinkIcon } from './unlink.svg?inline'
export { default as UnlockIcon } from './unlock.svg?inline'
export { default as UploadIcon } from './upload.svg?inline'
export { default as UserAddIcon } from './user-add.svg?inline'
export { default as UserCrossIcon } from './user-cross.svg?inline'
export { default as UserFilledIcon } from './user-filled.svg?inline'
export { default as UserOutlineIcon } from './user-outline.svg?inline'
export { default as VideoIcon } from './video.svg?inline'
export { default as WarningFilledIcon } from './warning-filled.svg?inline'
export { default as WarningOutlineIcon } from './warning-outline.svg?inline'
export { default as WorldIcon } from './world.svg?inline'
export { default as GhostDone } from './ghost-done.svg?inline'
